import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column">
            <h3 className="column-title">COMPANY &amp; LEGAL</h3>
            <ul className="footer-links">
              <li><Link to="/about" onClick={toTop}>About danecay</Link></li>
              <li><Link to="/policies" onClick={toTop}>Policy Center</Link></li>
              <li><Link to="/terms" onClick={toTop}>Terms of Use &amp; Sale</Link></li>
              <li><Link to="/privacy" onClick={toTop}>Privacy Policy</Link></li>
              <li><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></li>
              <li><Link to="/intellectual-property" onClick={toTop}>Intellectual Property</Link></li>
              <li><Link to="/accessibility" onClick={toTop}>Accessibility</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="column-title">ORDERS &amp; DELIVERY</h3>
            <ul className="footer-links">
              <li><Link to="/order-policy" onClick={toTop}>Orders &amp; Cancellations</Link></li>
              <li><Link to="/payment-policy" onClick={toTop}>Payment &amp; Billing</Link></li>
              <li><Link to="/pricing-promotions" onClick={toTop}>Pricing &amp; Promotions</Link></li>
              <li><Link to="/shipping" onClick={toTop}>Shipping</Link></li>
              <li><Link to="/duties-taxes" onClick={toTop}>Customs, Duties &amp; Taxes</Link></li>
              <li><Link to="/returns" onClick={toTop}>Returns</Link></li>
              <li><Link to="/warranty" onClick={toTop}>Quality &amp; Defects</Link></li>
              <li><Link to="/product-care" onClick={toTop}>Sizing &amp; Product Care</Link></li>
              <li><Link to="/faq" onClick={toTop}>FAQs</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="column-title">PRIVACY &amp; TRUST</h3>
            <ul className="footer-links">
              <li><Link to="/privacy-choices" onClick={toTop}>Privacy Choices</Link></li>
              <li><Link to="/marketing-communications" onClick={toTop}>Marketing Communications</Link></li>
              <li><Link to="/security" onClick={toTop}>Security &amp; Fraud Prevention</Link></li>
              <li><Link to="/product-safety" onClick={toTop}>Product Safety</Link></li>
              <li><Link to="/user-content" onClick={toTop}>Reviews &amp; User Content</Link></li>
              <li><Link to="/complaints" onClick={toTop}>Complaints &amp; Resolution</Link></li>
              <li><Link to="/contact" onClick={toTop}>Contact Us</Link></li>
              <li><a href="mailto:core@danecay.shop">core@danecay.shop</a></li>
            </ul>
          </div>

          <div className="footer-column brand-column">
            <h3 className="column-title">DANECAY QUERÉTARO</h3>
            <p className="footer-address">
              Av. del Marques 25, Rincones del marques, 76246 Santiago de Querétaro, Qro., MX<br />
              <a href="mailto:core@danecay.shop">core@danecay.shop</a>
            </p>
          </div>
        </div>

        <div className="footer-payments" aria-label="Supported payment methods">
          <span>Secure payments supported:</span>
          <span className="payment-badge">VISA</span>
          <span className="payment-badge">Mastercard</span>
          <span className="payment-badge">AMEX</span>
          <span className="payment-badge">Discover</span>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© {new Date().getFullYear()} danecay. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
